import React from "react";
import styles from "./Hamburger.module.scss";
import { useAppContext } from "../../../context/AppContext";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import { CustomSVG } from "@/components/_primitives/CustomSVG/CustomSVG";

export const Hamburger = ({ hasBackground }: { hasBackground: boolean }) => {
  const { openMenu, setOpenMenu } = useAppContext();
  const { getIcon, getLabel } = useGlobalContext();

  const label = openMenu
    ? getLabel("main_menu_close_label")
    : getLabel("main_menu_label");

  return (
    <button
      onClick={() => setOpenMenu((last) => !last)}
      className={`${styles["hamburger"]} ${hasBackground ? styles["has-background"] : ""} is-hidden-after-navbar-breakpoint`}
      aria-label={getLabel("arialabel_hamburger")}
      aria-controls="navbar-main"
      aria-expanded={openMenu}
    >
      {label && <span className={styles["menu-label"]}>{label}</span>}
      <span className={styles["icon-wrapper"]}>
        {openMenu ? (
          <CustomSVG
            src={getIcon("close")}
            wrapper={"span"}
            key={"close"}
            width={"100%"}
            height={"100%"}
            aria-hidden="true"
            className="is-flex"
          />
        ) : (
          <CustomSVG
            src={getIcon("menu")}
            wrapper={"span"}
            key={"open"}
            width={"100%"}
            height={"100%"}
            aria-hidden="true"
            className="is-flex"
          />
        )}
      </span>
    </button>
  );
};
